module.exports = __webpack_public_path__ + "media/images/ep3-cindy-1f13bc176009039ad826d896003a9262.png";